module.exports = __webpack_public_path__ + "files/9ebdaea80b4714dc4d27ae4d617c0d8b.png";